import { render, staticRenderFns } from "./UploadFoto.vue?vue&type=template&id=4f432bde&"
import script from "./UploadFoto.vue?vue&type=script&lang=js&"
export * from "./UploadFoto.vue?vue&type=script&lang=js&"
import style0 from "./UploadFoto.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports